<template>
  <div class="product" :key="course.id"
       :class="['theme-' + course.color_theme, {'theme-image': course.theme === 'image'}, {'no-progress': $settings('membership.show_progress') === '0'}]">
    <div class="tw-flex tw-flex-col tw-h-full"
         :class="{'concept-overlay': use_concept_overlay || use_scheduled_overlay}">
      <div class="tw-relative">
        <router-link :to="{ name: 'courses.show', params: { course_slug: course.slug }}"
                     :is="has_access_to_detail_page && !show_release_hero? 'router-link' : 'span'"
                     class="top tw-rounded-t">
          <template v-if="course.theme === 'circular'">
            <svg width="100%" height="100%" viewBox="0 0 42 42" class="progress-ring-wrapper"
                 v-if="$settings('membership.show_progress') == '1'">
              <circle class="progress-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent"
                      stroke-width="1.2"></circle>

              <circle class="progress-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent"
                      stroke-width="1.2" :stroke-dasharray="course.progress + ' ' + (100 - course.progress)"
                      stroke-dashoffset="25"></circle>
            </svg>
            <div class="image-wrapper">
              <div class="image">
                <img :src="course.image" :alt="course.name" class="tw-rounded-t" onerror="this.src='/img/image.resized.jpg?width=600'">
              </div>
            </div>
            <h2 class="tw-px-2 tw-text-center tw-leading-normal tw-text-white tw--mt-8 tw-z-10"
                :class="{'tw-text-gray-800': light_colors.includes(course.color_theme)}" v-text="course.name"></h2>
          </template>
          <template v-else>
            <img :src="course.image" :alt="course.name" onerror="this.src='/img/image.resized.jpg?width=600'" class="tw-rounded-t aspect-ratio-3-2">
          </template>
          <course-card-release-hero v-if="show_release_hero" :course="course"></course-card-release-hero>
        </router-link>
      </div>
      <div class="inner">
        <div>
          <div class="tw-flex tw-items-center tw-text-green-500 tw-text-sm tw-font-bold tw-text-uppercase"
               :class="course.theme === 'circular' ? 'tw-mb-4' : 'tw-mb-2'" v-if="course.progress == 100">
            <i class="fa fa-check tw-mr-1"></i>
            <span>{{ $t('membership.product') }} {{ $t('membership.course_finished') }}!</span>
          </div>
          <router-link :to="{ name: 'courses.show', params: { course_slug: course.slug } }"
                       v-if="course.theme === 'image'" :is="has_access_to_detail_page ? 'router-link' : 'span'">
            <h2 class="tw-font-bold tw-text-lg tw-text-gray-700 tw-leading-normal !tw-mb-2" v-text="course.name"></h2>
          </router-link>
          <div v-if="course.module_count > 1 || course.lesson_count > 1" class="facts">
            <template v-if="course.module_count > 1">
              <span>{{ course.module_count }} {{ $t('membership.modules') }}</span>
              <div class="dot"></div>
            </template>
            <span v-if="course.lesson_count > 1">{{ course.lesson_count }} {{ $t('membership.lessons') }}</span>
          </div>
          <p v-line-clamp:28="3" class="description" v-text="course.description"></p>
        </div>
        <div class="tw-flex tw-flex-col" :class="{'tw-justify-end': course.theme === 'image'}">
          <div v-if="use_concept_overlay || use_scheduled_overlay" class="concept-filler"/>
          <template v-else>
            <!-- Soon availabe for admins -->
            <!--                        <router-link v-if="$user.isModerator && !course.overview_visible && !is_released" :to="{ name: 'courses.show', params: { course_slug: course.slug } }" class="tw-flex tw-items-center hover:tw-opacity-75">-->
            <!--                            <i class="fa fa-lock tw-mr-4 tw-text-gray-600"></i>-->
            <!--                            <div class="tw-flex tw-flex-col">-->
            <!--                                <div class="tw-font-bold tw-text-gray-600">{{ $t('membership.soon_available') }}</div>-->
            <!--                                <div class="tw-text-gray-600">{{ $t('membership.in_concept_description') }}</div>-->
            <!--                            </div>-->
            <!--                        </router-link>-->

                        <!-- Start product -->
                        <router-link v-if="course.availability.available && is_released && course.progress === 0" :to="{ name: 'courses.show', params: { course_slug: course.slug } }">
                            <div class="watch-btn">
                                <i class="fa fa-play tw-pr-3 tw-text-gray-600"></i>
                                <p>Start {{ $t('membership.product').toLowerCase() }}</p>
                            </div>
                        </router-link>

                        <!-- Start again -->
                        <router-link v-else-if="course.availability.available && is_released && course.progress === 100" :to="{ name: 'lessons.show', params: { course_slug: course.slug, module_slug: course.last_activity.module.slug, lesson_slug: course.last_activity.slug } }">
                            <div class="watch-btn">
                                <i class="fa fa-play tw-pr-3 tw-text-gray-600"></i>
                                <p v-text="$t('membership.start_again')"></p>
                            </div>
                        </router-link>

                        <!-- Access until -->
                        <router-link v-else-if="access_to_course_until" :to="{ name: 'courses.show', params: { course_slug: course.slug } }">
                            <div class="watch-btn">
                                    <i :class="['fas tw-pr-3 tw-text-gray-600', access_to_course_until.below_seven_days_remaning ? 'fa-exclamation-triangle' : 'fa-clock']"></i>
                                    <p>{{ access_to_course_until.text }}</p>
                            </div>
                        </router-link>

                        <!-- Continue -->
                        <router-link v-else-if="course.availability.available && is_released && (course.progress > 0 && course.progress <= 100)" :to="{ name: 'lessons.show', params: { course_slug: course.slug, module_slug: course.last_activity.module.slug, lesson_slug: course.last_activity.slug } }">
                            <div class="watch-btn">
                                <i class="fa fa-play tw-pr-3 tw-text-gray-600"></i>
                                <p v-text="$t('membership.continue_progress_short')"></p>
                            </div>
                        </router-link>

                        <!-- More information -->
                        <router-link v-else-if="(!course.availability.available && !access_to_course_from) || course.availability.available && !course.is_released && course.details_visible" :to="{ name: 'courses.show', params: { course_slug: course.slug } }">
                            <div class="general-button btn-v2 slim tw-font-bold tw-mt-4">{{ $t('membership.more_information') }}</div>
                        </router-link>

                        <!-- Access soon -->
                        <router-link v-else-if="access_to_course_from" :to="{ name: 'courses.show', params: { course_slug: course.slug } }">
                            <div class="watch-btn">
                                <i class="fa fa-clock tw-pr-3 tw-text-gray-600"></i>
                                <p>{{ $t('membership.access_soon') }}</p>
                            </div>
                        </router-link>

                        <!-- Course progress -->
                        <div v-if="course.availability.available && is_released && $settings('membership.show_progress') == '1'" class="tw-relative tw-w-full tw-bg-gray-100 tw-rounded-lg tw-overflow-hidden tw-mt-3" :class="{'invisible': course.theme === 'circular'}" style="height: 4px;">
                            <div class="tw-absolute tw-h-full tw-bg-green-400 tw-rounded-lg" :style="{ width: course.progress + '%'}"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <router-link v-if="use_concept_overlay || use_scheduled_overlay" :to="{ name: 'courses.show', params: { course_slug: course.slug }}" class="tw-absolute tw-flex tw-items-center hover:tw-opacity-75 concept-notice">
            <template v-if="use_concept_overlay">
                <i class="fa fa-pencil tw-mr-4 tw-text-gray-600"></i>
                <div class="tw-flex tw-flex-col">
                    <div class="tw-font-bold tw-text-gray-600">{{ $t('membership.in_concept') }}</div>
                    <div class="tw-text-gray-600">{{ $t('membership.in_concept_description') }}</div>
                </div>
            </template>
            <template v-else-if="use_scheduled_overlay">
                <i class="fa fa-lock tw-mr-4 tw-text-gray-600"></i>
                <div class="tw-flex tw-flex-col">
                    <div class="tw-font-bold tw-text-gray-600">{{ $t('membership.soon_available') }}</div>
                    <div class="tw-text-gray-600">{{ $t('membership.in_concept_description') }}</div>
                </div>
            </template>
        </router-link>
    </div>
</template>

<script>
    import Global from '../../mixins/Global'
    import Course from '../../mixins/v2/Course'
    import CourseSkeleton from './CourseSkeleton.vue'
    import CourseCardReleaseHero from "./CourseCardReleaseHero.vue";

export default {
  name: 'CourseCard.vue',

        mixins: [Global, Course],

  components: {
    CourseCardReleaseHero,
    CourseSkeleton,
  },

  data() {
    return {
      light_colors: ['light_gray', 'light_green'],
    }
  },

  props: {
    course: {
      required: true
    },
  },

  computed: {
    use_concept_overlay() {
      return this.course.release_date === null && this.$user.isModerator;
    },

    use_scheduled_overlay() {
      return !this.course.is_released && !this.course.overview_visible && this.$user.isModerator;
    },

    is_released() {
      return this.course.is_released;
    },

    show_release_hero() {
      return this.course.release_date && !this.course.is_released && this.course.overview_visible;
    },

    has_access_to_detail_page() {
      if(this.$user.isModerator) {
        return true;
      }

      if(!this.$user.isModerator && !this.course.is_released && !this.course.details_visible) {
        return false
      }

				return true;
            }
        },
    }
</script>

<style lang="scss" scoped>
.aspect-ratio-3-2 {
  aspect-ratio: 3 / 2;
}

.concept-filler {
  height: 70.5px;
}

.concept-overlay > * {
  opacity: 0.3;
}

.concept-notice {
  bottom: 1.25rem;
  left: 1.25rem;
}

.mb-14-5 {
  bottom: 14.5px;
}

.product {
  @apply tw-relative tw-bg-white tw-mb-4 tw-rounded tw-flex tw-flex-col;
  // tw-w-full removed because tw-truncate then makes the parent overflow in safari
  box-shadow: 0px 8px 4px -3px #e2e5ea;

  .top {
    @apply tw-flex tw-flex-col tw-items-center tw-justify-between tw-py-6;
    // height: 233px;

    .progress-ring-wrapper {
      width: 155px;
      height: 215px;
      margin-top: -46px;

      .progress-segment {
        stroke: #fff;
      }
    }

    .image-wrapper {
      @apply tw-inline-flex tw-justify-center tw-items-center tw-rounded-full tw-absolute tw-w-full;
      top: 32px;

      .image {
        @apply tw-mx-auto tw-overflow-hidden;
        width: 100px;
        height: 100px;
        border-radius: 100%;

        img {
          @apply tw-object-cover;
          min-height: 100px;
        }
      }
    }

    h2 {
      @apply tw-font-semibold tw-text-xl tw-overflow-hidden tw-flex tw-items-end;
      margin-bottom: 0 !important;
      line-height: 1.5 !important;
      min-height: 53px;
    }
  }

  .inner {
    @apply tw-p-5 tw-flex tw-flex-col tw-justify-between;
    flex: 1;

    .facts {
      @apply tw-mb-4 tw-flex tw-items-center;

      span {
        @apply tw-font-bold tw-text-xs tw-uppercase;
        color: #cac8c8;
      }

      .dot {
        @apply tw-ml-2 tw-mr-2 tw-bg-gray-200;
        width: 4px;
        height: 4px;
        border-radius: 100%;
        margin-top: -1px;
      }
    }

    h2 {
      margin-bottom: 0.5rem !important;
    }

    p {
      @apply tw-text-gray-500 tw-leading-loose tw-flex-1;
      line-height: 28px;
      // overflow: hidden;
      // max-height: 140px;
    }

    .watch-btn {
      @apply tw-mt-2 tw-px-5 tw-flex tw-items-center tw-text-gray-700 tw-rounded-lg tw-cursor-pointer;
      padding-left: 0.75rem;
      margin-left: -0.75rem;

      i {
        @apply tw-pr-3;
      }

      p {
        @apply tw-font-bold tw-text-gray-600;
      }

      &:hover {
        @apply tw-opacity-75;
      }
    }
  }

  @mixin courses-theme($light_color, $color, $dark_color, $extra_light_color) {
    .top {
      background: linear-gradient(180deg, $light_color, $color);

      .progress-ring-wrapper {
        stroke: $dark_color;
      }

      .image-wrapper {
        .image {
          border: 2px solid $extra_light_color;
        }
      }
    }
  }

  &.theme-image {
    .top {
      @apply tw-py-0;
      background: none !important;
      height: auto;

      img {
        object-fit: cover;
        height: 100%;
        max-width: 100%;
        width: 100%;
      }
    }

    .inner {
      @apply tw-pb-5;
    }
  }

  &.no-progress {
    .top {
      height: 210px;

      svg {
        display: none;
      }

      .image-wrapper {
        @apply tw-relative tw-top-0;
      }
    }
  }

  &.theme-teal {
    @include courses-theme(#2ebda9, #27a291, #1c7d70, #2ec3af);
  }

  &.theme-pink {
    @include courses-theme(#ff4c89, #E91E63, #bf154f, #ff5b93);
  }

  &.theme-orange {
    @include courses-theme(#ffb74c, #FF9800, #da8303, #ffc166);
  }

  &.theme-blue {
    @include courses-theme(#65b9fd, #2196F4, #1a81d4, #57b4ff);
  }

  &.theme-light_blue {
    @include courses-theme(#81D4FA, #4FC3F7, #039BE5, #B3E5FC);
  }

  &.theme-red {
    @include courses-theme(#EF5350, #E53935, #C62828, #E57373);
  }

  &.theme-purple {
    @include courses-theme(#BA68C8, #9C27B0, #7B1FA2, #CE93D8);
  }

  &.theme-deep_purple {
    @include courses-theme(#9575CD, #673AB7, #512DA8, #B39DDB);
  }

  &.theme-indigo {
    @include courses-theme(#7986CB, #3F51B5, #303F9F, #C5CAE9);
  }

  &.theme-cyan {
    @include courses-theme(#00BCD4, #0097A7, #00838F, #4DD0E1);
  }

  &.theme-light_green {
    @include courses-theme(#DCEDC8, #AED581, #689F38, #F1F8E9);
  }

  &.theme-green {
    @include courses-theme(#4CAF50, #388E3C, #2E7D32, #81C784);
  }

  &.theme-light_orange {
    @include courses-theme(#E89A82, #EF7956, #D06748, #E6AA97);
  }

  &.theme-deep_orange {
    @include courses-theme(#FF8A65, #FF5722, #D84315, #FFAB91);
  }

  &.theme-gray {
    @include courses-theme(#616161, #212121, #1d1d1d, #757575);
  }

  &.theme-light_gray {
    @include courses-theme(#e3e4e6, #d3d4d8, #97989c, #eff1f5);
  }

  &.theme-metallic {
    @include courses-theme(#90A4AE, #607D8B, #455A64, #CFD8DC);
  }

  &.theme-brown {
    @include courses-theme(#A1887F, #795548, #5D4037, #D7CCC8);
  }
}
</style>
